/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zalo_Connection_ForeignInputs */

const vi_error_zalo_connection_foreign = /** @type {(inputs: Error_Zalo_Connection_ForeignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết nối Zalo đang lưu thuộc môi trường khác — máy chủ này không dùng. Kết nối lại nếu cần gửi tin ZBS ở đây.`)
};

/**

* @param {Error_Zalo_Connection_ForeignInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_connection_foreign = /** @type {((inputs?: Error_Zalo_Connection_ForeignInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Connection_ForeignInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_connection_foreign(inputs)
});